import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: any) => ({
  rootContainer: {
    display: "flex",
    flexWrap: "wrap", // Allow wrapping
    gap: "24px",
    width: "100%", // 👈 Important! Takes full width of parent
    boxSizing: "border-box",
  },
  flexItems: {
    flex: "1 1 250px",
    borderRadius: "14px",
    backgroundColor: "#FFFFFF",
    boxShadow: "6px 6px 54px 0px #0000000D",
    boxSizing: "border-box",
  },
  //
  gridSystem: {
    display: "grid",
    gridColumnStart: "1",
    gridColumnEnd: "5",
    columnGap: "15px",
    rowGap: "15px",
    //
    [theme.breakpoints.down("mxl")]: {
      gridRowStart: "1",
      gridRowEnd: "10",
    },
    //
    [theme.breakpoints.down("sm")]: {
      gridRowStart: "1",
      gridRowEnd: "20",
    },
  },
  activeAgents: {
    gridColumnStart: 1,
    gridColumnEnd: 2,
    //
    [theme.breakpoints.down("mxl")]: {
      gridColumnStart: 1,
      gridColumnEnd: 3,
    },
    //
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  activeCustomer: {
    gridColumnStart: 2,
    gridColumnEnd: 3,
    //
    [theme.breakpoints.down("mxl")]: {
      gridColumnStart: 3,
      gridColumnEnd: 5,
    },
    //
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  closedChat: {
    gridColumnStart: 3,
    gridColumnEnd: 4,
    //
    [theme.breakpoints.down("mxl")]: {
      gridColumnStart: 1,
      gridColumnEnd: 3,
    },
    //
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  totalChat: {
    gridColumnStart: 4,
    gridColumnEnd: 5,
    //
    [theme.breakpoints.down("mxl")]: {
      gridColumnStart: 3,
      gridColumnEnd: 5,
    },
    //
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  //
}));

export default useStyles;
